import { createSlice } from "@reduxjs/toolkit";

const privateFields = new Set([
  'credentials', 'tokens', 'oauthproviders', 'password', 'hashedpassword', 'passwordhash',
  'confirmpassword', 'passwordconfirmation', 'passphrase', 'studpassword', 'adminpassword',
  'financepassword', 'agentpassword', 'systemadminpassword', 'pin', 'hashedpin', 'pinhash',
  'pincode', 'userpin', 'pospin', 'terminalpin', 'accessToken', 'refreshToken', 'idToken',
  'sessionToken', 'fcmToken', 'deviceToken', 'pushToken', 'authToken', 'bearerToken',
  'resetToken', 'passwordResetToken', 'resetCode', 'passwordResetCode', 'verificationToken',
  'verificationCode', 'emailVerificationToken', 'phoneVerificationToken', 'otp', 'otpCode',
  'oneTimePassword', 'twoFactorSecret', 'totpSecret', 'mfaSecret', 'backupCodes', 'recoveryCodes',
  'securityAnswer', 'securityAnswers', 'secret', 'secrets', 'apiKey', 'apiSecret', 'privateKey',
  'clientSecret', 'authorization', 'cookie', 'credentialStamp', 'connectionString',
  'mongodbUri', 'databaseUri', 'salt', 'passwordSalt', 'pinSalt',
].map(field => field.toLowerCase()));
const privateField = key => {
  const field = key.replace(/[^a-z0-9]/gi, '').toLowerCase();
  return privateFields.has(field) || field.endsWith('password') || field.endsWith('passwordhash');
};

// Strip credential fields from server data and old saved records without changing their shape.
export const sanitizeClientData = (data, preserveSessionToken = false) => {
  const copy = (value, root = false) => {
    if (Array.isArray(value)) return value.map(item => copy(item));
    if (!value || Object.prototype.toString.call(value) !== '[object Object]') return value;
    return Object.fromEntries(Object.entries(value)
      .filter(([key]) => preserveSessionToken && root && key === 'sessionToken' || !privateField(key))
      .map(([key, item]) => [key, copy(item)]));
  };
  return copy(data, true);
};

// createing reducer with intial value
export const clientReducer = createSlice({
  name: "client_store",
  initialState: {
    isAuthenticated: false,
    accessType: "",
    sessionToken: null,
    activeUser: {},
    companiesDB: {},
    dashboard: {
      nav_title: "Dashboard",
      nav_trace: "dashboard",
      subNavBar_title: "",
      subNavBar_trace: "dashboard",
      toggleNavDropdown: "",
      currentTab: "",
    },
    printData: {},
  },
  reducers: {
    updateCompanySetupSnapshot: (state, action) => {
      const payload = action.payload || {};
      const client = state.companiesDB?.clientData;
      const changes = sanitizeClientData(payload.company || {});
      if (!client || (changes.clientId && changes.clientId !== client.clientId)) return;
      if (changes.businessProfile) client.businessProfile = {
        ...client.businessProfile, ...changes.businessProfile,
      };
      for (const key of ["bank_accounts", "preferences", "notifications"]) {
        if (changes[key] !== undefined) client[key] = changes[key];
      }
      if (changes.security) client.security = { ...client.security, ...changes.security };
      if (changes.metadata) client.metadata = { ...client.metadata, ...changes.metadata };
      for (const [key, source] of [["companyDefaultBranch", "branch"],
        ["companyDefaultInventory", "inventory"], ["companyDefaultWarehouse", "warehouse"]]) {
        if (payload[source]) state.companiesDB[key] = sanitizeClientData(payload[source]);
      }
    },
    updateCompanySubscriptionSnapshot: (state, action) => {
      const client = state.companiesDB?.clientData;
      if (!client || client.clientId !== action.payload?.clientId) return;
      if (action.payload.subscription) client.subscription = sanitizeClientData(action.payload.subscription);
    },
    updateCompanyPreferences:(state,action)=>{if(state.companiesDB?.clientData?.clientId===action.payload.clientId)state.companiesDB.clientData.preferences=action.payload.preferences;},
    startclientAction: (state, action) => {
      const { dbPayload, authenticationType, sessionToken } = action.payload;
      return {
        ...state,
        companiesDB: sanitizeClientData(dbPayload),
        isAuthenticated: true,
        accessType: authenticationType,
        sessionToken: sessionToken || null,
        
    dashboard: {
      ...state.dashboard, 
       nav_title: "Dashboard",
      nav_trace: "dashboard",
      subNavBar_title: "",
      subNavBar_trace: "dashboard",
      toggleNavDropdown: "",
      currentTab: "",
    },
      };
    },

    dispathcDashboardNavigator: (state, action) => {
      // state.dashboard.nav_title = action.payload.title;
      console.log("payload", action.payload);
      if (action.payload?.children) {
        state.dashboard.nav_trace = action.payload.active;
      } else {
        state.dashboard.nav_trace = action.payload.active;
        state.dashboard.subNavBar_title = action.payload.title;
        state.dashboard.subNavBar_trace = action.payload.active;
        state.dashboard.currentTab = action.payload.active;
        state.dashboard.nav_title = action.payload.title;
      }
    },

    dispatchDashboardSubNavigator: (state, action) => {
      state.dashboard.subNavBar_title = action.payload.title;
      state.dashboard.subNavBar_trace = action.payload.hook;
      state.dashboard.currentTab = action.payload.hook;
      state.dashboard.nav_title = action.payload.main;
    },

    dispatchCurrentTAB: (state, action) => {
      state.dashboard.currentTab = action.payload.item;
    },

    dispatchClientOpenIndex: (state, action) => {
      state.dashboard.toggleNavDropdown = action.payload.index;
    },

    dispatchPrintData: (state, action) => {
      state.printData = sanitizeClientData(action.payload.data);
    },

    logOut: (state, action) => {
      return {
        ...state,
        companiesDB: {},
        dashboard: {}, 
        isAuthenticated: false,
        accessType: "",
        sessionToken: null,
        printData: {},
      };
    },
  },
});

export const {
  updateCompanyPreferences,
  updateCompanySetupSnapshot,
  startclientAction,
  updateCompanySubscriptionSnapshot,
  logOut,
  dispathcDashboardNavigator,
  dispatchDashboardSubNavigator,
  dispatchClientOpenIndex,
  dispatchCurrentTAB,
  dispatchPrintData,
} = clientReducer.actions;

export default clientReducer.reducer;
